import React, { Fragment } from 'react'
import CardEmpty from "Utils/Cards/CardEmpty";
import { RenderNumber, RenderNumberPercentage } from "Utils/renderField/renderReadField"
import { RenderGramos } from '../../../../Utils/renderField/renderReadField';
import { getColorVariacionDRC } from '../../../../Utils/LaboratorioDRC/Common';
import "react-step-progress-bar/styles.css";
import './DatosDRC.css';
import { calcularDRCLatexOriginal } from '../../../../Utils/LaboratorioDRC/CalculosDRCLatex';

/**
 * Componente para renderizar los datos de DRC
 * Se creó para refactorizar el contenido en el componente general (AnalisisVer)
 * Solo se hicieron cambios respectivos a la variación DRC
 * @param {*} props propiedades del componente
 * @param {object} props.item objeto con los datos del DRC
 * @param {boolean} props.verVariacionDRC bandera para mostrar la variación DRC
 * @returns {JSX.Element} componente de datos de DRC
 */
export const DatosDRC = (props) => {
    const { item, verVariacionDRC } = props;

    const registrosDRC = item.datos_drc || [];

    return (
        <div className="row my-3 datos-drc-latex-ver__container">
            <div className="col-12">
                <CardEmpty noShadow >
                    <div className="datos-drc-latex-ver__top mt-2 mb-3">
                        <h6 className="">DATOS DRC</h6>
                        <div className="datos-drc-latex-ver__top-fields">
                            <div className="d-flex align-items-center">
                                <span className="verde-secundario bold mr-2">DRC PROMEDIO:</span>
                                <RenderNumberPercentage value={item.drc_promedio} />
                            </div>
                            {verVariacionDRC &&
                                <div className="d-flex align-items-center">
                                    <span className="verde-secundario bold mr-2">VARIACIÓN DRC:</span>
                                    {item.aplica_variacion_drc ?
                                        <RenderNumber value={item.variacion_drc} suffix=" %" decimalScale={2}
                                            className={getColorVariacionDRC(item.variacion_drc)} /> :
                                        <span className="gris">NO APLICADA</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div className="new-table-wrapper pd-small mb-3">
                        <table>
                            <thead>
                                <tr>
                                    {item.aplica_variacion_drc && verVariacionDRC ?
                                        <Fragment>
                                            <th className='text-right datos-drc-latex-ver__tbl-long-name'>PESO SECO ORIGINAL</th>
                                            <th className='text-right datos-drc-latex-ver__tbl-long-name'>PESO SECO CON VARIACIÓN DRC</th>
                                        </Fragment>
                                        :
                                        <th className='text-right'>PESO SECO</th>
                                    }
                                    <th className='text-right'>PESO PLATO</th>
                                    <th className='text-right'>PESO HÚMEDO</th>
                                    {item.aplica_variacion_drc && verVariacionDRC ?
                                        <Fragment>
                                            <th className='text-right'>DRC ORIGINAL</th>
                                            <th className='text-right'>DRC CON VARIACIÓN</th>
                                        </Fragment>
                                        :
                                        <th className='text-right'>DRC</th>
                                    }
                                    <th>HORA INGRESO</th>
                                    <th>HORA SALIDA</th>
                                    <th>LABORATORISTA</th>
                                </tr>
                            </thead>
                            <tbody>
                                {registrosDRC.map((dato_actual, index) => (
                                    <tr key={index}>
                                        {item.aplica_variacion_drc && verVariacionDRC ?
                                            <Fragment>
                                                <td className='text-right td--no-wrap'>
                                                    <RenderGramos value={dato_actual.peso_seco_original} />
                                                </td>
                                                <td className='text-right td--no-wrap'>
                                                    <RenderGramos value={dato_actual.peso_seco} />
                                                </td>
                                            </Fragment>
                                            :
                                            <td className='text-right td--no-wrap'>
                                                <RenderGramos value={dato_actual.peso_seco_original} />
                                            </td>
                                        }
                                        <td className='text-right td--no-wrap'>
                                            <RenderGramos value={dato_actual.peso_plato} />
                                        </td>
                                        <td className='text-right td--no-wrap'>
                                            <RenderGramos value={dato_actual.peso_humedo} />
                                        </td>
                                        {item.aplica_variacion_drc && verVariacionDRC ?
                                            <Fragment>
                                                <td className='text-right td--no-wrap'>
                                                    <RenderNumberPercentage
                                                        value={calcularDRCLatexOriginal(dato_actual)}
                                                    />
                                                </td>
                                                <td className='text-right td--no-wrap'>
                                                    <RenderNumberPercentage value={dato_actual.total} />
                                                </td>
                                            </Fragment>
                                            :
                                            <td className='text-right td--no-wrap'>
                                                <RenderNumberPercentage value={dato_actual.total} />
                                            </td>
                                        }
                                        <td>{dato_actual.hora_ingreso}</td>
                                        <td>{dato_actual.hora_salida}</td>
                                        <td>{dato_actual.laboratorista_nombre ? dato_actual.laboratorista_nombre : dato_actual.laboratorista.nombre}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </CardEmpty>
            </div>
        </div>
    )
}
